<template>
    <TabsContent
        :force-mount="forceMount"
        :value="value"
        :class="animationClasses"
        class="left-0 top-0 z-10 h-full w-full space-y-10 outline-none transition-all data-[state=inactive]:invisible data-[state=active]:z-30">
        <div class="relative flex h-full w-full justify-between outline-none">
            <slot />
        </div>
    </TabsContent>
</template>

<script setup lang="ts">
import type { TBaseTabAnimation } from '~/components/base/base-tabs/base-tabs.types'

const props = defineProps({
    value: {
        type: String as PropType<string>,
        required: true,
    },
    animation: {
        type: String as PropType<TBaseTabAnimation>,
        default: 'none',
    },
    forceMount: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
})

const animationClasses = computed<string[]>(() => {
    switch (props.animation) {
        case 'fade-scale': {
            return [
                'data-[state=inactive]:absolute',
                'data-[state=active]:animate-fade-scale-open',
                'data-[state=inactive]:animate-fade-scale-close',
            ]
        }
        case 'reverse': {
            return [
                'absolute',
                'duration-300',
                'data-[state=active]:delay-300',
                'data-[state=active]:opacity-100',
                'data-[state=inactive]:opacity-0',
            ]
        }
        default: {
            return ['duration-300']
        }
    }
})
</script>
